import React from 'react';
import { Check } from 'lucide-react';

const StepIndicator = ({ currentStep, completedSteps, steps }) => {
  return (
    <div className="flex items-center justify-center mb-8">
      {steps.map((step, index) => {
        const stepNumber = index + 1;
        const isCompleted = completedSteps.includes(stepNumber);
        const isCurrent = currentStep === stepNumber;
        
        return (
          <React.Fragment key={stepNumber}>
            <div className="flex flex-col items-center">
              {/* Step Circle */}
              <div
                className={`
                  w-12 h-12 rounded-full flex items-center justify-center text-sm font-semibold
                  transition-all duration-200
                  ${
                    isCompleted
                      ? 'bg-yellow-500 text-white'
                      : isCurrent
                      ? 'bg-yellow-500 text-white ring-4 ring-blue-100'
                      : 'bg-gray-200 text-gray-500'
                  }
                `}
              >
                {isCompleted ? (
                  <Check className="w-5 h-5" />
                ) : (
                  stepNumber
                )}
              </div>
              
              {/* Step Label */}
              <div className="mt-2 text-center">
                <div
                  className={`
                    text-xs font-medium uppercase tracking-wider weight-semibold
                    ${isCurrent ? 'text-black ' : isCompleted ? 'text-gray-600' : 'text-gray-400'}
                  `}
                >
                  {step.label}
                </div>
                <div className="text-xs text-gray-500 mt-0.5">
                  {step.subtitle}
                </div>
              </div>
            </div>
            
            {/* Connector Line */}
            {index < steps.length - 1 && (
              <div
                className={`
                  w-24 h-0.5 mx-4 mt-[-24px]
                  transition-all duration-200
                  ${isCompleted ? 'bg-yellow-500' : 'bg-gray-200'}
                `}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default StepIndicator;
